import attendo from '../img/logos-fi/attendo.jpg';
import caruna from '../img/logos-fi/Caruna.png';
import elenia from '../img/logos-fi/Elenia.png';
import hehku from '../img/logos-fi/hehku.png';
import kiertokapulaLogo from '../img/logos-fi/kiertokapula-logo.png';
import lahtiAqua from '../img/logos-fi/LahtiAqua.png';
import mehilainen from '../img/logos-fi/Mehilainen.png';
import oomi from '../img/logos-fi/Oomi.png';
import sanoma from '../img/logos-fi/Sanoma.png';
import sato from '../img/logos-fi/SATO.png';
import terveystalo from '../img/logos-fi/Terveystalo.png';
import vare from '../img/logos-fi/vare.png';

import bdx from '../img/logos-se/BDX.png';
import bredablickLogo from '../img/logos-se/Bredablick-logo.webp';
import carlsberg from '../img/logos-se/Carlsberg.jpg';
import ellevio from '../img/logos-se/Ellevio.png';
import feelgoodLogo from '../img/logos-se/feelgood-logo.png';
import greenCargo from '../img/logos-se/GreenCargo.png';
import hsb from '../img/logos-se/HSB.png';
import nge from '../img/logos-se/NGE.png';
import skoogs from '../img/logos-se/Skoogs.jpg';
import srv from '../img/logos-se/SRV.jpg';
import storumanEnergi from '../img/logos-se/StorumanEnergi.png';
import strawberryLogo from '../img/logos-se/strawberry-logo.png';

import aneoLogo from '../img/logos-no/Aneo_logo.svg.png';
import bodoEnergi from '../img/logos-no/BodoEnergi.png';
import cheapEnergy from '../img/logos-no/cheap_energy.webp';
import kildenKraft from '../img/logos-no/Kilden-kraft.webp';
import klarkraft from '../img/logos-no/klarkraft.png';
import meko from '../img/logos-no/Meko.png';
import motkraftAs from '../img/logos-no/motkraft_as.png';
import nordvestnettLogo from '../img/logos-no/nordvestnett-logo.png';
import norskGjenvinning from '../img/logos-no/norsk_gjenvinning.webp';
import sagaEnergi from '../img/logos-no/SagaEnergi.png';
import schenkerLogo from '../img/logos-no/Schenker_logo.png';
import veniMeteringGreen from '../img/logos-no/VENIMetering_Green.png';

import useI18n from "./useI18n";

const logosFi = [
    { src: attendo, alt: "Attendo" },
    { src: caruna, alt: "Caruna" },
    { src: elenia, alt: "Elenia" },
    { src: hehku, alt: "Hehku" },
    { src: kiertokapulaLogo, alt: "Kiertokapula" },
    { src: lahtiAqua, alt: "Lahti Aqua" },
    { src: mehilainen, alt: "Mehiläinen" },
    { src: oomi, alt: "Oomi" },
    { src: sanoma, alt: "Sanoma" },
    { src: sato, alt: "SATO" },
    { src: terveystalo, alt: "Terveystalo" },
    { src: vare, alt: "Väre" }
];

const logosSe = [
    { src: bdx, alt: "BDX" },
    { src: bredablickLogo, alt: "Bredablick" },
    { src: carlsberg, alt: "Carlsberg" },
    { src: ellevio, alt: "Ellevio" },
    { src: feelgoodLogo, alt: "Feelgood" },
    { src: greenCargo, alt: "Green Cargo" },
    { src: hsb, alt: "HSB" },
    { src: nge, alt: "NGE" },
    { src: skoogs, alt: "Skoogs" },
    { src: srv, alt: "SRV" },
    { src: storumanEnergi, alt: "Storuman Energi" },
    { src: strawberryLogo, alt: "Strawberry" }
];

const logosNo = [
    { src: aneoLogo, alt: "Aneo" },
    { src: bodoEnergi, alt: "Bodø Energi" },
    { src: cheapEnergy, alt: "Cheap Energy" },
    { src: kildenKraft, alt: "Kilden Kraft" },
    { src: klarkraft, alt: "Klarkraft" },
    { src: meko, alt: "Meko" },
    { src: motkraftAs, alt: "Motkraft AS" },
    { src: nordvestnettLogo, alt: "Nordvestnett" },
    { src: norskGjenvinning, alt: "Norsk Gjenvinning" },
    { src: sagaEnergi, alt: "Saga Energi" },
    { src: schenkerLogo, alt: "Schenker" },
    { src: veniMeteringGreen, alt: "VENI Metering Green" }
];

const logos = {
    fi: logosFi,
    se: logosSe,
    no: logosNo
};

const useReferenceLogos = () => {
    const { getCountry } = useI18n();
    const country = getCountry();

    const resolveLogos = () => {
        return logos[country] ?? logos.fi;
    }

    return {
        resolveLogos
    };
}

export default useReferenceLogos;
